import React, { useState, useEffect, useRef } from 'react'

import './StepBackground.scss'

const StepBackground = ({
  backgroundImageId,
  backgroundColor,
  mobileBackgroundId,
  backgroundImageAlt = '',
  mobileBackgroundImageAlt = '',
  backgroundImageSrc: backgroundImageSrcProp,
  mobileBackgroundImageSrc: mobileBackgroundImageSrcProp,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
  backgroundOpacity,
}) => {

  const [backgroundImageSrc, setBackgroundImageSrc] = useState(
    ``)
  const [mobileBackgroundImageSrc, setMobileBackgroundImageSrc] = useState(
    ``)
    const isIdFavorable = (id, idState) => {
      return (
        id &&
        id !== 'null' &&
        id !== 'undefined' &&
        id !== 'false' &&
        id !== '0' &&
        id !== 'NaN' &&
        id !== 'Infinity' &&
        `${process.env.SITE_ASSET_URL}/${id}` !== idState
      )
    }
    useEffect(() => {
      if (backgroundImageSrcProp) {
        if (backgroundImageSrcProp !== backgroundImageSrc) {
          setBackgroundImageSrc(backgroundImageSrcProp)
        }
      } else if (isIdFavorable(backgroundImageId, backgroundImageSrc)) {
        setBackgroundImageSrc(`${process.env.SITE_ASSET_URL}/${backgroundImageId}`)
      }
      if (mobileBackgroundImageSrcProp) {
        if (mobileBackgroundImageSrcProp !== mobileBackgroundImageSrc) {
          setMobileBackgroundImageSrc(mobileBackgroundImageSrcProp)
        }
      } else if (isIdFavorable(mobileBackgroundId, mobileBackgroundImageSrc)) {
        setMobileBackgroundImageSrc(`${process.env.SITE_ASSET_URL}/${mobileBackgroundId}`)
      }
    }, [backgroundImageId, mobileBackgroundId, backgroundImageSrcProp, mobileBackgroundImageSrcProp])
  // Puck-managed bg: use CSS background-image so size/position/repeat/opacity work.
  const isPuckManaged = !!backgroundImageSrcProp || !!mobileBackgroundImageSrcProp

  if (isPuckManaged) {
    const bgLayerStyle = {
      backgroundImage: backgroundImageSrc ? `url("${backgroundImageSrc}")` : undefined,
      backgroundSize: backgroundSize || 'cover',
      backgroundPosition: backgroundPosition || 'center center',
      backgroundRepeat: backgroundRepeat || 'no-repeat',
      opacity: typeof backgroundOpacity === 'number' ? backgroundOpacity : undefined,
      width: '100%',
      height: '100%',
    }
    return (
      <div
        className="step-background-container"
        style={{ '--background-color': backgroundColor }}
      >
        <div className="step-background">
          <div className="step-background-image-layer" style={bgLayerStyle} />
          {mobileBackgroundImageSrc && (
            <style
              dangerouslySetInnerHTML={{
                __html: `@media (max-width: 900px) { .step-background-image-layer { background-image: url("${mobileBackgroundImageSrc}") !important; } }`,
              }}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <div
      className="step-background-container"
      style={{
        '--background-color': backgroundColor,
      }}
    >
      <div className="step-background">
        <div className={`lazy-image-container`}>
          <picture>
            {mobileBackgroundImageSrc && (
              <source
                srcSet={mobileBackgroundImageSrc}
                media="(max-width: 900px)"
                width="100%"
              />
            )}

            <source
              srcSet={backgroundImageSrc}
              media="(min-width: 901px)"
            />

            {/* an img tag is required for the picture tag to render. this is a transparent 1px gif. */}
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt={backgroundImageAlt || mobileBackgroundImageAlt || ""} />

          </picture>
        </div>
      </div>
    </div>
  )
}
export default StepBackground
